module.exports = __webpack_public_path__ + "img/vote-4.87863d03.png";